import React from "react";
import AnimateLine from "../../../common/AnimateLine";
import Breadcrumb from "../../../common/Breadcrumb";
import SubscribArea from "../../../common/SubscribArea";
import ProjectDetailsWrap1 from "../BCVolumetrisch/ProjectDetailsWrap1";

function ProjectDetails1() {
  return (
    <>
      <div className="ebrandy-wrap">
        <AnimateLine />
        <Breadcrumb pageName="BC Volumetrisch" pageTitle="BC Volumetrisch" />
        <ProjectDetailsWrap1 />
        <SubscribArea />
      </div>
    </>
  );
}

export default ProjectDetails1;
